import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { DrawerFilterProductionSupervisor } from "./Components/DrawerFilter/DrawerFilterProductionSupervisor";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { useTheme } from "@mui/material";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { ReportProductionSupervisorPDF } from "./Components/PDF/ReportProductionSupervisorPDF";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportProductionSupervisor = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportProductionContract } = useContextReportsProduction();
  const hasData = !!listReportProductionContract?.data?.length;
  const theme = useTheme();

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterProductionSupervisor key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de produção por supervisores com filtros personalizados"
        title="Relatório de produção por supervisor"
      />

      <ReportProductionSupervisorPDF />

      {!hasData && !loadingGravar && (
        <NoEmptyPdfCore />
      )}
    </>
  );
};
